/*       */

import { label, componentPipelines } from 'app/utils/designer/pipeline/settings/common/commonImportant';

const panels = settingValues => [
    {
        type: 'panel',
        properties: {
            header: settingValues.data.group,
            iconName: settingValues.data.iconName,
            iconType: settingValues.data.iconType,
            expanded: true,
            collapsible: false,
        },
        children: [
            {
                type: 'header',
                properties: {
                    variant: 'h6',
                    text: settingValues.data.title,
                },
            },
        ],
    },
    {
        type: 'panel',
        properties: {
            header: 'Status',
            expanded: true,
        },
        children: [
            {
                type: 'header',
                properties: {
                    variant: 'h6',
                    text: 'No errors',
                },
            },
            {
                type: 'button',
                properties: {
                    iconName: 'play-box',
                    label: 'Start',
                },
            },
        ],
    },
    {
        type: 'panel',
        properties: {
            header: 'General Information',
            expanded: true,
        },
        children: [label(settingValues.pipelineMonitor), componentPipelines],
    },
];

export default {
    defaults: {},
    panels: settingValues => panels(settingValues),
};
